import React, { PureComponent } from "react";
import { Typography, Checkbox, CircularProgress } from "@material-ui/core";

class ArticleDistribution extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      feeds: {},
      feedLabels: {},
      loading: true, // ⏳ initial loading state
    };
  }

  componentDidMount() {
    const { fetchAllFeedStatus } = this.props;
    fetchAllFeedStatus().then((data) => {
      if (data && data.feeds) {
        this.setState({
          feeds: data.feeds,
          feedLabels: data.feedLabels || {},
          loading: false, // ✅ turn off loading after data fetch
        });
      } else {
        this.setState({ loading: false });
      }
    });
  }

  handleFeedToggle = (feedKey) => {
    const specialConfirmKeys = ['msn_gallery', 'noindex'];
    const isSpecial = specialConfirmKeys.includes(feedKey);

    if (isSpecial) {
      const action = this.state.feeds[feedKey] ? 'disable' : 'enable';
      const confirmMessage =
        feedKey === 'msn_gallery'
          ? `Are you sure you want to ${action} MSN Gallery?`
          : `Are you sure you want to ${action} Noindex?`;

      const confirmed = window.confirm(confirmMessage);
      if (!confirmed) return;
    }

    const updatedFeeds = {
      ...this.state.feeds,
      [feedKey]: !this.state.feeds[feedKey],
    };

    this.setState({ feeds: updatedFeeds });

    const { updateAllFeedStatus } = this.props;
    if (updateAllFeedStatus) {
      updateAllFeedStatus(updatedFeeds);
    }
  };

  render() {
    const { feeds, feedLabels, loading } = this.state;

    if (loading) {
      return (
        <div style={{ padding: 20, display: "flex", alignItems: "center" }}>
          <CircularProgress size={20} style={{ marginRight: 10 }} />
          <Typography variant="body2">Loading feed settings...</Typography>
        </div>
      );
    }

    return (
      <>
        <Typography variant="subtitle1" style={{ marginTop: 20 }}>
          Feed Distribution
        </Typography>

        {Object.keys(feeds).map((key) => (
          <div key={key}>
            <Checkbox
              checked={feeds[key]}
              onChange={() => this.handleFeedToggle(key)}
              color="primary"
            />
            {feedLabels[key] || key}
          </div>
        ))}
      </>
    );
  }
}

export default ArticleDistribution;
